import { WebStorageStateStore } from 'oidc-client-ts';

/**
 * Since this code needs to be same for silent refresh html and authService
 * if feels right to locate this code here so that changes can happen in one place.
 */
export const getUserStorage = () => new WebStorageStateStore({ store: window.localStorage });
